import { render } from "./Desc.vue?vue&type=template&id=6aee5cfa&scoped=true"
import script from "./Desc.vue?vue&type=script&lang=js"
export * from "./Desc.vue?vue&type=script&lang=js"

import "./Desc.vue?vue&type=style&index=0&id=6aee5cfa&scoped=true&lang=scss"
import "./Desc.vue?vue&type=style&index=1&id=6aee5cfa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aee5cfa"]])

export default __exports__